<template>
    <!-- Render in a separate html file is incorrect -->
    <div>
        <template v-if="loading && caseModel == null">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </template>
        <template v-else>
            <template v-if="caseModel">
                <template v-if="isSuccessful">
                    <div class="col-md-12">
                        <div class="mb-3">
                            <h1>Case set to solved</h1>
                            <div class="mt-1">
                                Case title: {{ caseModel.title }}
                            </div>
                        </div>
                        <div>
                            <p>Thank you for your Feedback.</p>
                            <p>We have closed the case in our system.</p>
                            <p class="mt-2">
                                In case you have further questions or feedback,
                                please reply to the latest E-Mail you have
                                received from ifm-support@bmwgroup.com regarding
                                this case.
                            </p>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <SimpleCaseSolution
                        v-if="!isComplexSolution"
                        :case-model="caseModel"
                        @solve="simpleSolveHandler"></SimpleCaseSolution>
                    <ComplexCaseSolution
                        v-else
                        :case-model="caseModel"
                        @solve="solveComplexHandler">
                        Board Case
                    </ComplexCaseSolution>
                </template>
            </template>
            <template v-else>
                <h1>Error!</h1>
            </template>
        </template>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BaseSolutionComponent from "../BaseSolutionComponent";
import SimpleCaseSolution from "@/components/SimpleCaseSolution";
import ComplexCaseSolution from "@/components/ComplexCaseSolution";
import { solutionModule } from "@/store/modules/solution";
import { SolutionActions } from "@/store/modules/solution/actions";
import { SimpleSolveDTO } from "@/models/solution/SimpleSolveDTO";
import { ComplexSolveDTO } from "@/models/solution/ComplexSolveDTO";
import caseSolutionHelper from "@/services/caseSolutionHelper";

export default defineComponent({
    extends: BaseSolutionComponent,
    components: {
        SimpleCaseSolution,
        ComplexCaseSolution
    },
    data() {
        return {
            isSuccessful: false
        };
    },
    computed: {
        isComplexSolution(): boolean {
            return (
                this.caseModel !== null &&
                caseSolutionHelper.isComplexSolutionCase(this.caseModel)
            );
        }
    },
    methods: {
        ...solutionModule.mapActions({
            simpleSolve: SolutionActions.SimpleSolve,
            complexSolve: SolutionActions.ComplexSolve
        }),
        async simpleSolveHandler(solution: string): Promise<void> {
            if (this.tokenData?.token) {
                await this.simpleSolve({
                    token: this.tokenData.token,
                    solution
                } as SimpleSolveDTO);
                this.isSuccessful = true;
            }
        },
        async solveComplexHandler(solveData: ComplexSolveDTO): Promise<void> {
            if (this.tokenData?.token) {
                solveData.token = this.tokenData.token;
                await this.complexSolve(solveData);
                this.isSuccessful = true;
            }
        }
    },
    created() {
        if (this.tokenData) {
            this.getSolutionCase(this.tokenData);
        } else {
            this.showError("Invalid Token");
        }
    }
});
</script>
